import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { LocalizePipe } from '../../../localize/localize.pipe';
import { TranslateModule } from '@ngx-translate/core';
import { ErrorPageComponent } from './error-page.component';
import { UnescapePipe } from '../../shared/pipes/unescape.pipe';
import { ErrorComponent } from '../../shared/error/error.component';


@NgModule({
  declarations: [
    ErrorPageComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    LocalizePipe,
    TranslateModule,
    UnescapePipe,
    ErrorComponent,
  ],
  exports: [
    ErrorPageComponent
  ]
})
export class ErrorPageModule { }
